module.exports = __webpack_public_path__ + "static/media/add_company_icon.ebdb801f.svg";